// extracted by mini-css-extract-plugin
export var arrow = "T_9";
export var body = "T_c";
export var circle = "T_dS";
export var customer = "T_dR";
export var feedback = "T_dQ";
export var feedbacks = "T_dN";
export var footer = "T_bR";
export var footerText = "T_bS";
export var left = "T_b8";
export var nameLocation = "T_dT";
export var padding = "T_dj";
export var right = "T_ck";
export var section = "T_j";
export var selected = "T_bg";
export var selectors = "T_dM";
export var subtitle = "T_b7";
export var text = "T_bw";
export var title = "T_g";
export var wrapper = "T_dP";